<div class="text-nowrap">
  <label id="{{'chart-input-label-' + chartInput.id}}" for="{{'chart-input-' + chartInput.id}}"
         class="form-label mb-0 me-1">{{chartInput.label}}</label>
</div>
<div class="input-group input-group-sm has-validation">
  <input id="{{'chart-input-' + chartInput.id}}"
         class="form-control"
         [class.is-invalid]="isInvalid"
         [class.is-valid]="!!value?.length && isInvalid === false"
         [(ngModel)]="value"
         (ngModelChange)="valueChangedWithDebounceTime()"
         [ngbTooltip]="tipContent"
         triggers="focusin:keydown"
         placement="bottom">
  <button *ngIf="value"
          class="btn btn-light border-dark"
          type="button"
          (click)="clearChartInputValue()">
    <i class="fa-light fa-xmark"></i>
  </button>
  <div class="invalid-tooltip">
    <i class="fa-light fa-circle-exclamation me-1"></i>{{errorMessage}}
  </div>
</div>

<ng-template #tipContent>Available operators: "*" (any text), "?" (any single character), "|" (or)</ng-template>
